/**
 * WTM CORE — theme-level behavior kept outside Dawn core JS where possible.
 *
 * Responsibilities:
 * 1. Open policy links in a new tab (preserves live-theme behavior).
 * 2. Adjust all header icons and cart-count contrast to the rendered header background.
 */

(() => {
  const getRgb = (value) => {
    const match = value?.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if (!match) return null;
    return [Number(match[1]), Number(match[2]), Number(match[3])];
  };

  const relativeLuminance = ([r, g, b]) => {
    const channels = [r, g, b].map((channel) => {
      const value = channel / 255;
      return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * channels[0] + 0.7152 * channels[1] + 0.0722 * channels[2];
  };

  const updateHeaderIconContrast = () => {
    const header = document.querySelector('header.header');
    if (!header) return;

    const rgb = getRgb(window.getComputedStyle(header).backgroundColor);
    if (!rgb) return;

    const foreground = relativeLuminance(rgb) > 0.5 ? '#000000' : '#ffffff';
    const bubbleForeground = foreground === '#000000' ? '#ffffff' : '#000000';

    // Dawn icons use currentColor. Set the foreground on every header icon so
    // search, customer account, menu and cart stay readable on partner-shop headers.
    document.querySelectorAll('.header__icon').forEach((element) => {
      element.style.color = foreground;

      // Important: do NOT overwrite --shopify-account-color-text here.
      // Dawn uses that variable for the complete account dialog, not just the icon.
      // The signed-in state is rendered as WTM's clean account icon overlay in CSS;
      // only its background remains transparent here.
      if (element.matches('shopify-account.header__icon--account')) {
        element.style.setProperty('--shopify-account-signed-in-avatar-color-background', 'transparent');
      }
    });

    document.querySelectorAll('.cart-count-bubble').forEach((element) => {
      element.style.backgroundColor = foreground;
      element.style.color = bubbleForeground;
    });
  };

  const updatePolicyLinks = () => {
    document.querySelectorAll('.policies a').forEach((link) => {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  };

  const init = () => {
    updatePolicyLinks();
    updateHeaderIconContrast();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
